<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectGoodsList" v-model="query.goodsId"
								item-text="goodsName" item-value="id" label="商品" dense outlined></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
						
					
							
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn small @click="showAddDialog" color="info">新增采购订单</v-btn>
							
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip>
				</template>
			
			
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 添加dialog -->
		<v-dialog title="新增采购订单" v-model="add.dialog" max-width="600">
			<v-card>
				<v-card-title>
					<span>新增采购订单</span>
					<v-spacer></v-spacer>
					<v-icon @click="add.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-select :items="selectGoodsList" v-model="add.order.goodsId"
							item-text="goodsName" item-value="id" label="商品名称" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-text-field label="供应商名称" v-model="add.order.supplierName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="采购价格"  type="number" v-model="add.order.price" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="数量" type="number" v-model="add.order.quantity" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="交接人" v-model="add.order.bizUserName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="订单备注" v-model="add.order.memo" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<span>订单总金额：</span>
							<span v-if="add.order.price && add.order.quantity" color="red">
								{{(add.order.quantity * add.order.price).toFixed(2)}} 元
							</span>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddOder" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		

	</v-card>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "purchase-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '采购管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '商品',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '供应商',
							value: 'supplierName',
							sortable: false
						},
						{
							text: '价格',
							value: 'price',
							sortable: false
						},
						{
							text: '数量',
							value: 'quantity',
							sortable: false
						},
						{
							text: '总价',
							value: 'totalFee',
							sortable: false
						},
						{
							text: '状态',
							align: 'center',
							value: 'status',
							sortable: false
						},
						{
							text: '制单人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList:[], //选择门店数据源
				selectGoodsList:[], //选择商品数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
		
				},
				add:{
					dialog: false,
					order:{
						shopId:"",
						goodsId:"",
						quantity:"",
						price:"",
						totalFee:"",
						supplierName:"",
						bizUserName:"",
						memo:""
					}
				}
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(){
				this.add.dialog = true;
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/purchase/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				}
				else if (state === "0") {
					stName = "已取消";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddOder(){
				//提交订单
				// api
				
				if(!this.add.order.price){
					this.$noty.error("请输入价格");
					return
				}
				
				if (!utils.isDecimal(this.add.order.price)){
					this.$noty.error("价格只能为正数且最多2位小数");
					return
				}
				
				const that = this;
				let url = `/erp/purchase/create`;
				let postData = {...this.add.order};
				postData.shopId = this.shopId;
							
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>

<style>
</style>
